import moment from 'moment'
import { rando } from '@nastyox/rando.js'
moment.locale('ru');

const arrangementOfIcons = (text, title = false, white, endIcon = false, isEn = false) => {
	// const keyWords = [/музе/, /галере/, /экспонат/, /искусств/, /шедевр/, /[^А-Яа-яёЁ]мир[^А-Яа-яёЁ]/];
	const keyWords = isEn ? [/museum/, /gallery/, /exhibit/, / art/, /masterpiece/] : [/музе/, /галере/, /экспонат/, /искусств/, /шедевр/];
  const htmlImg = '<img src="images/icons/';
	const svgs = isEn ? ['museum', 'gallery', 'exhibit', 'art', 'masterpiece'] : ['museum', 'gallery', 'exhibit', 'art', 'masterpiece'];
  const words = text.split(' ');
  let fullImgHtml
	const arr = words.map(word => {
		let htmlWord = word + ' ';
		keyWords.forEach((key, i) => {
			if (white && i === 5) {
				return
			}
			if (new RegExp(key).test(word.toLowerCase())) {
        fullImgHtml = white ? `${htmlImg}${svgs[i]}-white.svg"> ` : `${htmlImg}${svgs[i]}.svg"> `
        if(!endIcon) {
          htmlWord = title ? fullImgHtml + htmlWord : htmlWord + fullImgHtml;
          htmlWord = ` <span class="nowrap">${htmlWord}</span> `;
        }
			}
		})
		return htmlWord;
  })
  if(endIcon && fullImgHtml) {
    arr.push(fullImgHtml)
  }
	return arr.join('').replace('м2', 'м<span class="small-top">2</span>')
}

const debounce = (func, wait, immediate) => {
  let timeout
  return function () {
    let context = this
    let args = arguments
    let later = function () {
      timeout = null
      if (!immediate) func.apply(context, args)
    }
    let callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (callNow) func.apply(context, args)
  }
}

const getDateDiff = (date, lang = 'ru', format = 'YYYY-MM-DD, h:mm:ss') => {
  moment.locale(lang);
  return moment(date, format).fromNow();
}

const formatDate = (date, format = 'DD.MM.YYYY', stepMonths, lang='ru') => {
  moment.locale(lang);
  let formatted = moment.utc(date);
  formatted = moment(formatted).add(1, 'd')
  if (stepMonths) {
    if (stepMonths > 0) {
      formatted.add(stepMonths, 'months')
    } else {
      formatted.subtract(stepMonths * -1, 'months')
    }
  }
  return formatted.format(format);
}

const scrolingGallery = (state, refName) => {
  return {
    mousedown: (e) => {
      e = e || window.event;
      e.preventDefault();
      state.down = true;
      state.x = e.clientX;
      state.movingActive = true;
    },
    mouseup: (e) => {
      e = e || window.event;
      state.down = false;
    },
    mousemove: (e) => {
      if(state.down){
        if (state.x) {
          state.$refs[refName].scrollBy(state.x - e.clientX, 0)
        }
        state.x = e.clientX;
        state.movingActive = false;
      }
    },
    mouseleave: () => {
      state.down = false;
    },
    // touchstart: (e) => {
    //   e = e || window.event;
    //   // e.preventDefault();
    //   state.down = true;
    //   state.x = e.changedTouches[0].clientX;
    // },
    // touchend: (e) => {
    //   e = e || window.event;
    //   state.down = false;
    // },
    // touchmove: (e) => {
    //   if(state.down){
    //     if (state.x) {
    //       state.$refs[refName].scrollBy(state.x - e.changedTouches[0].clientX, 0)
    //     }
    //     state.x = e.changedTouches[0].clientX;
    //   }
    // },
    // touchleave: () => {
    //   state.down = false;
    // }
  }
}

const handleTouchScroling = (state, refName) => {
  return {
    touchstart: (e) => {
      e = e || window.event;
      // e.preventDefault();
      state.down = true;
      state.y = e.changedTouches[0].clientY;
    },
    touchend: (e) => {
      e = e || window.event;
      state.down = false;
    },
    touchmove: (e) => {
      if(state.down){
        if (state.y) {
          state.$refs[refName].scrollBy(0, state.y - e.changedTouches[0].clientY)
        }
        state.y = e.changedTouches[0].clientY;
      }
    },
    touchleave: () => {
      state.down = false;
    }
  }
}

const isEmail = (email) => {
  const regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(email);
}

const isTextWithoutNumbers = (text) => {
  // var Reg6 = new RegExp("^[A-zА-яЁё]+$");
  // const regex = /^[A-zА-яЁё]+$$/;
  const regex = /[0-9]+/;
  return !regex.test(text);
}

const checkAllValues = (values, incognito) => {
  let result = true
  Object.entries(values).forEach((val) => {
    if(incognito && (val[0] === 'name' || val[0] === 'surname')) {
      return
    } else if (!val[1]) {
      result = false
    }
  })
  return result
}

const declOfNum = (number) => {
  const cases = [2, 0, 1, 1, 1, 2];
  return (number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5 ]
}

const getContentByCode = (arr, code, prop='content') => {
  const array = arr || []
  const item = array.find((elem) => elem.code === code);
  return item ? item[prop] : ''
}

const getItemByCode = (arr, code) => {
  const array = arr || []
  const item = array.find((elem) => elem.code === code);
  return item
}

const getArrForTitle = (text) => {
  if (text) {
    return text.split('<br>')
  } else {
    return ''
  }
}

function declension(total, expressions = ['пользователь','пользователя','пользователей']) {
  const num = Number(total)
  //const expressions = ['пользователь','пользователя','пользователей']
  let result;
  let count = num % 100;
  if (count >= 5 && count <= 20) {
      result = expressions['2'];
  } else {
      count = count % 10;
      if (count === 1) {
          result = expressions['0'];
      } else if (count >= 2 && count <= 4) {
          result = expressions['1'];
      } else {
          result = expressions['2'];
      }
  }
  return result;
}

// generate random positions
function generatePositionsArray (maxX, maxY, safeRadius, irregularity) {
  // declarations
  let positionsArray = [];
  let r, c;
  let rows;
  let columns;
  // count the amount of rows and columns
  rows = Math.floor(maxY / safeRadius);
  columns = Math.floor(maxX / safeRadius);
  // loop through rows
  for (r = 1; r <= rows; r += 1) {
    // loop through columns
    for (c = 1; c <= columns; c += 1) {
      // populate array with point object
      positionsArray.push({
        x: Math.round(maxX * c / columns) + rando(irregularity * -1, irregularity),
        y: Math.round(maxY * r / rows) + rando(irregularity * -1, irregularity)
      });
    }
  }
  // return array
  return positionsArray;
}
// positions = generatePositionsArray(2400, 1600, 40, 10);

// get random position from positions array
function getRandomPosition (array, removeTaken) {
  // declarations
  let randomIndex;
  let coordinates;
  // get random index
  randomIndex = rando(0, array.length - 1);
  // get random item from array
  coordinates = array[randomIndex];
  // check if remove taken
  if (removeTaken) {
    // remove element from array
    array.splice(randomIndex, 1);
  }
  // return position
  return coordinates;
}

function getRandomPositions (array, ...generateArgs) {
  const posArray = generatePositionsArray(...generateArgs)

  return array.map(() => getRandomPosition(posArray, true))
}

function loadGsap () {
  return new Promise((resolve, reject) => {
    if (typeof window !== 'undefined' && !window.gsap) {
      const s = document.createElement('script')
      s.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.6.0/gsap.min.js'
      s.addEventListener('load', (e) => { console.log('sock', e); resolve('wat') })
      s.addEventListener('error', reject)
      document.querySelector('head').appendChild(s)
    } else {
      resolve()
    }
  })
}

function checkAuthor (item, author) {
  if (!author) {
    return ''
  }
  let result = ''
  if (!!item.unconfirmedAuthorIds && item.unconfirmedAuthorIds.includes(String(author.id))) {
    result += '<img class="unconfirmedAuthorIds" src="/app/images/icons/authorQues.svg">'
  }
  return author.name + result
}

export {
	arrangementOfIcons,
	debounce,
  getDateDiff,
  formatDate,
  scrolingGallery,
  isEmail,
  isTextWithoutNumbers,
  checkAllValues,
  declOfNum,
  getContentByCode,
  getItemByCode,
  getArrForTitle,
  declension,
  handleTouchScroling,
  getRandomPosition,
  generatePositionsArray,
  getRandomPositions,
  loadGsap,
  checkAuthor
}
